module.exports = __webpack_public_path__ + "static/media/employees.empty.2fb16a3e.png";